// We only need to import the modules necessary for initial render
import ClaimsRoute from './Claims'
import ClientsRoute from './Clients'
import ConciergeRoute from './Concierge'
import CoreLayout from '../layouts/PageLayout/PageLayoutContainer'
import DeviceRoute from './Device'
import Home from './Home'
import ImagesRoute from './Images'
import LoginRoute from './Login'
import PcbRoute from './PCB'
import QCListRoute from './QCList'
import QCRoute from './QC'
import StatsRoute from './Stats'
import TestRoute from './Test'
import VersionsRoute from './Versions'

// import CounterRoute from './Counter'

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */

export const createRoutes = (store) => {
  return {
    path        : '/',
    component   : CoreLayout,
    indexRoute  : Home,
    childRoutes : [
      // CounterRoute(store)
      ClaimsRoute,
      ClientsRoute,
      ConciergeRoute,
      DeviceRoute,
      ImagesRoute,
      LoginRoute,
      PcbRoute,
      QCListRoute,
      QCRoute,
      StatsRoute,
      TestRoute,
      VersionsRoute,
    ]
  }
}

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js